<template>
    <div class="layout-topbar px-4">
        <div class="justify-content-start">
            <a href="/">
                <img
                    src="https://shoptok-assets.s3.eu-central-1.amazonaws.com/business_manager/Logo.svg"
                    alt="Image"
                    height="40"
                    class="topbar-logo"
                />
            </a>
        </div>
        <div class="justify-content-end">
            <Button label="Login" class="layout-menu-login" @click="goToPage('Login')" />
            <Button label="Register" class="layout-menu-registered" @click="goToPage('Register')" />
        </div>
    </div>
</template>

<script>
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";

export default {
    name: "AppNavbar",
    setup() {
        const route = useRoute();
        const router = useRouter();
        const menu = ref(false);

        const scrollToSection = (section) => {
            if (route.name !== "Home") {
                router.push({ name: "Home", params: { section } });
            }
            if (document.getElementById(section)) {
                document.getElementById(section).scrollIntoView({ behavior: "smooth" });
            }
            menu.value = false;
        };

        const goToPage = (pageName) => {
            menu.value = false;
            router.push({ name: pageName });
        };

        return { menu, scrollToSection, goToPage };
    },
};
</script>

<style lang="scss" scoped>
.menu {
    &__button {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        position: relative;
        color: var(--text-color-secondary);
        border-radius: 50%;
        width: 3rem;
        height: 3rem;
        cursor: pointer;

        &:hover {
            color: var(--text-color);
            background-color: var(--surface-hover);
        }

        i {
            font-size: 1.5rem;
        }

        span {
            font-size: 1rem;
            display: none;
        }
    }
}
</style>
